import React from "react";
import {useNavigate} from "react-router";

const ErrorPageContainer = ({ children }) => {
  const navigate = useNavigate();
  const retourHandler = () => {
    navigate(-1);
  };
  return React.cloneElement(children, {
    onRetour: retourHandler,
  });
};

export default ErrorPageContainer;
